const e = {
  "published-date": "published-date"
};
export {
  e as default
};
